import React, { useEffect } from 'react';
import AccountDashboardWidgetBase from "./AccountDashboardWidgetBase";
import { Routes } from '../../../routes/routes';
import { ReactComponent as MyRingGroups } from '../../../assets/accountDashboard/MyRingGroups.svg';
import {useTranslation} from 'react-i18next';
import { actions } from '../../../store';
import {useDispatch, useSelector} from 'react-redux';
import AccountDashboardLoader from './AccountDashboardLoader';
import { ReduxState } from '../../../store/types';
import SwitchWithLabel from '../../../components/SwitchWithLabel/SwitchWithLabel';
import { UpdateHuntgroupsSubscriptionPayload } from '../../../store/actions/accountDashboard/payloads';
import { useStyles } from './AccountDashboardRingGroupsWidget.utils';

const AccountDashboardRingGroupsWidget: React.VFC = () => {
    const classes = useStyles();
    const {t} = useTranslation();
    const dispatch = useDispatch();

    const {ringGroups, isLoadingRingGroups} = useSelector(
        (state: ReduxState) => state.accountDashboard,
    );
    
    const {accountDetails} = useSelector((state: ReduxState) => state.accountControlPanel);

    useEffect(() => {
        dispatch(actions.getAccountDashboardRingGroupList.request());
    }, []);
    
    return (<AccountDashboardWidgetBase
        route={Routes.AccountRingGroups}
        icon={<MyRingGroups />}
        label={t('screens:accountDashboard.myRingGroups')}
    >
        {isLoadingRingGroups && (<AccountDashboardLoader />)}
        {ringGroups?.map(rg => (
            <div className={classes.myRingGroupRow} key={'ring_group_' + rg.id}>
            <div className={classes.ringGroupCodeLabel}>{rg.id}</div>
            <div className={classes.ringGroupNameLabel}>{rg.name}</div>
            <div className={classes.ringGroupSwitchContainer}>
                <SwitchWithLabel
                    id={"loggedStatus_" + rg.id}
                    label={t('screens:accountDashboard.loggedIn')}
                    className={classes.switch}
                    customLabelClass={classes.ringGroupSwitchLabel}
                    setValue={(_, value) => {
                        const payload: UpdateHuntgroupsSubscriptionPayload = {
                            i_account: accountDetails?.i_account,
                            subscribe_to_huntgroups: value ? [{id: rg.id}] : undefined,
                            unsubscribe_from_huntgroups: value ? undefined : [{id: rg.id}],
                            callback: () => {
                                dispatch(actions.getAccountDashboardRingGroupList.request());
                            }
                        };
                        dispatch(actions.updateHuntgroupsSubscription.request(payload));
                    }}
                    value={(rg?.assigned_extensions?.[0]?.hunt_active ?? "N") == "Y"}
                        field={"loggedStatus_" + rg.id}
                />
            </div>
        </div>
        ))}
        
    </AccountDashboardWidgetBase>
    );
};

export default AccountDashboardRingGroupsWidget;